import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import siteContent from '../../content/site/content.json';

const getIcon = (name) => {
  const Icon = Icons[name];
  return Icon ? <Icon className="w-6 h-6" /> : null;
};

const DifferentiatorsSection = () => {
  const d = siteContent.differentiators;
  if (!d) return null;

  return (
    <section id="differentiators" className="py-16 lg:py-24 bg-[#FFF8F5] scroll-mt-20" data-testid="differentiators-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1F1E1E] mb-4">{d.heading}</h2>
          <p className="text-base text-[#3B3535]/70 leading-relaxed">{d.subheading}</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {(d.items || []).map((item, i) => (
            <div
              key={i}
              data-testid={`differentiator-card-${i}`}
              className="bg-white rounded-3xl p-8 border border-gray-100 shadow-sm hover:shadow-xl hover:border-[#B5541B]/20 transition-all duration-300 flex flex-col"
            >
              <div className="w-12 h-12 rounded-xl bg-[#B5541B]/10 flex items-center justify-center text-[#B5541B] mb-5">
                {getIcon(item.icon)}
              </div>
              <h3 className="text-lg font-bold text-[#1F1E1E] mb-3 leading-snug">{item.title}</h3>
              <p className="text-sm text-[#3B3535]/75 leading-relaxed mb-4 flex-1">{item.description}</p>
              {item.supporting && (
                <p className="text-sm font-semibold text-[#B5541B] italic mb-4">{item.supporting}</p>
              )}
              {item.linkLabel && item.linkHref && (
                <Link
                  to={item.linkHref}
                  data-testid={`differentiator-link-${i}`}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#B5541B] hover:text-[#8B3F14] transition-colors group"
                >
                  {item.linkLabel}
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DifferentiatorsSection;
